import { render } from "./supportPcIndex.vue?vue&type=template&id=3205631e"
import script from "./supportPcIndex.vue?vue&type=script&lang=js"
export * from "./supportPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__